import { takeLatest, put, delay } from 'redux-saga/effects';
import * as succeed from '../../ui/success';
import { PATIENT_INFO } from '../../../constants/routes';
import { consts as checkEligibilityConsts } from '../requests/check-insurance-eligibility';
import { consts as insuranceEligibilityManualActivationConsts } from '../../profiles/insurance-eligibility-manual-activations';

function* succeedWorker() {
  const url = window.location.href;

  const parts = url.split('/');

  if (parts.includes(PATIENT_INFO)) {
    yield delay(500);

    yield put({
      type: succeed.consts.UPDATE,
      payload: { id: 'appointments.form.insuranceDetails,success' },
    });
  }
}

export default function* handleInsuranceSucceedUpdate() {
  yield takeLatest(
    [
      checkEligibilityConsts.SUCCEED,
      insuranceEligibilityManualActivationConsts.SUCCEED,
    ],
    succeedWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/sagas/handle-insurance-succeed-update.js